module.exports = __webpack_public_path__ + "static/media/iguazu-falls-43.dc629f32.jpg";